import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import Axios from "../../../axios/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toTitleCase } from "../../utils/StringUtil";

export const Header = ({ businessType, cart }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);

  const [productType, setProductType] = useState(
    sessionStorage.getItem("businessType") || ""
  );
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [cartTotal, setCartTotal] = useState(0);
  const [excelModalOpen, setExcelModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [supplierInfo, setSupplierInfo] = useState(null);
  const [customerBalance, setCustomerBalance] = useState(null);
  const referenceExcelLink = productType === "Rental"
  ? "/excel/RentalOrderCreateExcelFormat.xlsx" // rental-specific reference Excel
  : "/excel/OrderCreateExcelFormat.xlsx";       // common reference Excel for others


  useEffect(() => {
    const fetchCartTotal = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;

      if (!customerId) return;

      try {
        const res = await Axios.get(`/cart/${customerId}`);
        const businessType = sessionStorage.getItem("businessType");

        const filteredItems =
          res.data?.items?.filter((item) =>
            item.productType.includes(businessType)
          ) || [];
        const total = filteredItems.reduce(
          (sum, item) => sum + item.totalItemPrice,
          0
        );
        setCartTotal(total);
      } catch (error) {
        console.error("Error fetching cart total in header:", error);
      }
    };

    fetchCartTotal();
  }, []);

  useEffect(() => {
    const supplierInfoString = sessionStorage.getItem("supplierInfo");
    if (supplierInfoString) {
      const parsed = JSON.parse(supplierInfoString);
      setSupplierInfo(parsed);
    }
  }, []);

  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    const storedProductType = sessionStorage.getItem("businessType");
    if (storedProductType) {
      setProductType(storedProductType);
    }
  }, []);

  console.log("searchResults",searchResults)

  useEffect(() => {
    const fetchCustomerBalance = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;
      if (!customerId) return;

      try {
        const res = await Axios.get(`/customer/get/${customerId}`);
        setCustomerBalance(parseFloat(res.data?.balance || 0));
      } catch (error) {
        console.error("Error fetching customer balance:", error);
      }
    };

    fetchCustomerBalance();
  }, []);

  // const handleSearch = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   setSearchResults([]);

  //   if (!productType || !searchKeyword.trim()) {
  //     setError('Both product type and search keyword are required.');
  //     return;
  //   }

  //   try {
  //     const response = await fetch('http://localhost:3000/searchfilter', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ type: productType, productName: searchKeyword }),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.statusText}`);
  //     }

  //     const results = await response.json();
  //     setSearchResults(results);
  //     setShowModal(true);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setSearchResults([]);

    if (!productType || !searchKeyword.trim()) {
      setError("Both product type and search keyword are required.");
      setShowModal(true);
      return;
    }

    try {
      const response = await Axios.post("/searchfilter", {
        type: productType,
        productName: searchKeyword,
      });

      setSearchResults(response.data);
      setShowModal(true);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setShowModal(true);
    }
  };

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      const parsed = JSON.parse(userInfoString);
      setUserInfo(parsed);
    } else {
      console.log("No user info found in session storage.");
    }
  };

  const handleLogout = (event) => {
    event.preventDefault();

    // Show confirmation dialog before proceeding with logout
    setConfirmMessage("Are you sure you want to log out?");
    setConfirmAction(() => () => {
      sessionStorage.removeItem("userInfo");
      navigate("/");
      window.location.reload();
    });
    setConfirmModal(true);
  };

  const handleProductClick = (product) => {
    const type = product.productType?.[0]; // optional chaining + default to first type

    if (product.productType?.includes("Engineering")) {
      navigate(`/engineering/product/single/${product._id}`);
    } else if (product.productType?.includes("Auto-Spare")) {
      navigate(`/singleproduct/${product._id}`);
    } else if (product.productType?.includes("Building")) {
      navigate(`/others/product/single/${product._id}`);
    } else {
      navigate(`/rental/product/single/${product._id}`);
    }
  };

  const handleExcelUpload = async () => {
    if (!selectedFile) return;

    setUploadLoading(true);
    setUploadError(null);
    setUploadResponse(null);

    const formData = new FormData();
    formData.append("file", selectedFile);

    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    formData.append("customerName", userInfo.username);
    formData.append("customerId", userInfo.customerId);
    formData.append("businessType", sessionStorage.getItem("businessType"));

    try {
      const response = await Axios.post("/upload-excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setUploadResponse(response.data.results);
      setExcelModalOpen(false);
      toast.success("Your order has been placed successfully!");
      console.log("Upload Success:", response.data);
    } catch (err) {
      console.error("Upload Error:", err);
      setUploadError("Upload failed. Please try again.");
    } finally {
      setUploadLoading(false);
    }
  };

  const closeNavbar = () => {
    const nav = document.getElementById("navbarNavDropdown");
    if (nav && nav.classList.contains("show")) {
      // Bootstrap collapse trigger
      document.querySelector(".navbar-toggler")?.click();
    }
  };

  return (
    <header className="es-header w-100">
      <div className="container-fluid p-0">
        <div className="top-header w-100">
          <div className="row">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <Link className="navbar-brand in-mob" to="/">
                <img
                  src={"/images/logo.svg"}
                  height="60"
                  alt="Asia Part Souq"
                />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse p-5"
                id="navbarNavDropdown"
              >
                <ul className="navbar-nav ml-auto">
                  {/* Common Links */}
                  <div className="d-none d-md-block d-lg-none">
                    <br />
                    <br />
                    <br />
                  </div>
                  <li className="nav-item">
                    <Link
                      className="nav-link nav-home"
                      to="/"
                      onClick={closeNavbar}
                    >
                      Home
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/about"
                      onClick={closeNavbar}
                    >
                      About us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/whole-products"
                      onClick={closeNavbar}
                    >
                      Products
                    </Link>
                  </li>
                  <li className="nav-item">
                    {/* <Link className="nav-link" to="/account">
                    My Account
                  </Link> */}
                    {userInfo && (
                      <Link
                        className="nav-link"
                        to="/account"
                        onClick={closeNavbar}
                      >
                        My Account
                      </Link>
                    )}
                  </li>

                  {/* Common Links */}

                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/review"
                      onClick={closeNavbar}
                    >
                      Customer reviews
                    </Link>
                  </li>
<li className="nav-item">
  <Link
    className="nav-link"
    to="/contact"
    onClick={closeNavbar}
  >
    Contact Us
  </Link>
</li>

                  {/* <a
                    className="form-inline phone-link"
                    href="tel:9731234567986"
                  >
                    <img src={'/images/help.svg'} alt="Help" />
                    +973 123456 7986
                  </a> */}
                  <div className="form-inline phone-link">
                    <img src={"/images/help.svg"} alt="Help" />
                    +973 123456 7986
                  </div>
                  <li className="nav-item d-flex align-items-center ml-3">
                    <select
                      className="form-control form-select-type"
                      value={productType}
                      onChange={(e) => {
                        const selectedType = e.target.value;
                        const routeMap = {
                          Engineering: "/engineering-home",
                          "Marine And Engineering": "/engineering-home",
                          Building: "/others-home",
                          Rental: "/rental-home",
                          "Auto-Spare": "/",
                        };
                        if (selectedType) {
                          closeNavbar();
                          setConfirmMessage(
                            `Are you sure you want to switch to the ${selectedType} page?`
                          );
                          setConfirmAction(() => () => {
                            setProductType(selectedType);
                            sessionStorage.setItem(
                              "businessType",
                              selectedType
                            );
                            navigate(routeMap[selectedType] || "/");
                          });
                          setConfirmModal(true);
                        }
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="Auto-Spare">Auto-Spare</option>
                      <option value="Engineering">Marine And Engineering</option>
                      <option value="Building">Building</option>
                      <option value="Rental">Rental</option>
                    </select>

                  </li>

                  <form className="form-inline btn-grp">
                    {userInfo ? (
                      <div className="d-flex flex-column align-items-end pr-3">
                        {userInfo.username && (
                          <div
                            className="text-muted mb-1"
                            style={{ fontSize: "0.9rem" }}
                          >
                            Welcome{" "}
                            <strong>{toTitleCase(userInfo.username)}</strong>
                          </div>
                        )}
                        <button
                          className="btn btn-danger"
                          onClick={(e) => {
                            closeNavbar();
                            handleLogout(e);
                          }}
                        >
                          Logout
                        </button>
                      </div>
                    ) : supplierInfo ? (
                      <div className="d-flex flex-column align-items-end pr-3">
                        <div
                          className="text-muted mb-1"
                          style={{ fontSize: "0.9rem" }}
                        >
                          Welcome Supplier{" "}
                          <strong>{toTitleCase(supplierInfo.username)}</strong>
                        </div>
                        <Link
                          className="btn btn-primary"
                          to="/SupplierDashboard"
                          onClick={closeNavbar}
                        >
                          Go to Supplier Dashboard
                        </Link>
                      </div>
                    ) : (
                      <>
                        <Link
                          className="blue-border-btn hvr-float"
                          to="/signup"
                              onClick={closeNavbar}
                                  style={{textDecoration: 'none'}}
                        >
                          Signup
                        </Link>
                        <Link
                          className="blue-btn hvr-float"
                          to="/login"
                              onClick={closeNavbar}
                              style={{textDecoration: 'none'}}
                        >
                          Login
                        </Link>
                      </>
                    )}
                  </form>
                </ul>
              </div>
            </nav>
          </div>
        </div>
        <div className="row bottom-strip"  >
          <nav
            className="navbar navbar-expand-lg navbar-light herader-serach-width"
           
          >
            <Link className="navbar-brand in-desktop" to="/">
              <img src={"/images/logo.svg"} height="60" alt="Asia Part Souq" />
            </Link>
            {/* <div className="input-group search">
              <input
                type="text"
                className="form-control"
                placeholder="Search keyword here"
              />
              <div className="input-group-append">
                <button className="btn search-btn" type="button">
                  <Link to={`/searchfile`}></Link>
                  Search
                </button>
              </div>
            </div> */}
            <div className="search-width" >
              <form onSubmit={handleSearch} className="input-group search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search keyword here"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
                <div className="input-group-append">
                  <button
                    className="btn search-btn"
                    type="submit"
                    onClick={(e) => {
                      closeNavbar();
                    }}
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title> </Modal.Title>
              </Modal.Header>
            <Modal.Body style={{ 
  padding: '20px',
  maxHeight: '500px',
  overflowY: 'auto',
  backgroundColor: '#f8f9fa'
}}>
  {error ? (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px'
  }}>
    <img
      src="/images/no-data.avif"
      alt="No data"
      style={{
        width: '250px',
        maxWidth: '100%',
        marginBottom: '20px',
        opacity: 0.8
      }}
    />
    <p style={{
      color: '#6c757d',
      fontSize: '16px',
      fontWeight: '500'
    }}>
      {error} 
    </p>
  </div>
  ) : searchResults.length > 0 ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {searchResults.map((product) => (
        <div
          key={product._id}
          onClick={() => handleProductClick(product)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            padding: '15px',
            backgroundColor: '#ffffff',
            borderRadius: '10px',
            border: '1px solid #e0e0e0',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
            e.currentTarget.style.borderColor = '#007bff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
            e.currentTarget.style.borderColor = '#e0e0e0';
          }}
        >
          {/* Product Image */}
          <div style={{
            width: '80px',
            height: '80px',
            minWidth: '80px',
            borderRadius: '8px',
            overflow: 'hidden',
            backgroundColor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #e0e0e0'
          }}>
            <img
              src={product?.images?.[0]?.url || product?.images?.[0]?.url || '/images/placeholder-product.png'}
              alt={product.name || product.partName || product.meterialName}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div style="color: #999; font-size: 12px; text-align: center;">No Image</div>';
              }}
            />
          </div>

          {/* Product Details */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <h5 style={{
              margin: '0 0 8px 0',
              fontSize: '16px',
              fontWeight: '600',
              color: '#212529',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {product.name || product.partName || product.meterialName}
            </h5>
            
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px',
              fontSize: '13px',
              color: '#6c757d'
            }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <strong style={{ color: '#495057' }}>Type:</strong>
                <span style={{
                  padding: '2px 8px',
                  backgroundColor: '#e7f3ff',
                  color: '#0066cc',
                  borderRadius: '4px',
                  fontSize: '12px'
                }}>
                  {product.productType}
                </span>
              </span>
              
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <strong style={{ color: '#495057' }}>Part No:</strong>
                <span>{product.partNo}</span>
              </span>
              
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <strong style={{ color: '#495057' }}>Year:</strong>
                <span>{product.year}</span>
              </span>
            </div>
          </div>

          {/* Arrow Icon */}
          <div style={{
            color: '#007bff',
            fontSize: '20px',
            opacity: 0.5,
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.transform = 'translateX(5px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '0.5';
            e.currentTarget.style.transform = 'translateX(0)';
          }}>
            →
          </div>
        </div>
      ))}
    </div>
  ) : (
   <div style={{
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 20px',
  color: '#6c757d'
}}>
  <img
    src="/images/no-data.avif"
    alt="No data"
    style={{
      width: '250px',
      maxWidth: '100%',
      marginBottom: '20px',
      opacity: 0.8
    }}
  />
  <p style={{
    fontSize: '16px',
    fontWeight: '500',
    margin: 0
  }}>
    No products found
  </p>
  <p style={{
    fontSize: '14px',
    margin: '8px 0 0 0',
    opacity: 0.7,
    textAlign: 'center',
    maxWidth: '300px'
  }}>
    Don't worry if the product is unavailable. You can mention it in your quotation request, and we will try to source it for you.
  </p>
</div>

  )}
</Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={() => setShowModal(false)} style={{ backgroundColor: "#1A54A5" }}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
            <ToastContainer position="top-right" autoClose={3000} />

            <Modal
              show={excelModalOpen}
              onHide={() => setExcelModalOpen(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Upload Excel Quotation</Modal.Title>
              </Modal.Header>
            <Modal.Body>
  <div style={{ width: "100%", position: "relative" }}>
    <div style={{ width: "90%", marginRight: "20px", marginLeft: "20px" }}>
      <input
        type="file"
        accept=".xlsx,.xls"
        id="fileUpload"
        onChange={(e) => setSelectedFile(e.target.files[0])}
        style={{ display: "none" }}
      />
      <label
        htmlFor="fileUpload"
        style={{
          display: "block",
          width: "100%",
          padding: "10px",
          textAlign: "center",
          border: "1px solid #ccc",
          color: "#fff",
          borderRadius: "6px",
          cursor: "pointer",
          backgroundColor: "#1b52a3",
           
        }}
      >
        📁 Choose Excel File
      </label>
    </div>

    {/* Reference text link on right side */}
   <div style={{ textAlign: "right", marginTop: "5px", marginRight: "25px" }}>
  <a
    href={referenceExcelLink}
    download={`Reference-${productType || "Excel"}.xlsx`}
    style={{ fontSize: "14px", color: "#1b52a3", textDecoration: "none", cursor: "pointer" }}
  >
    Download reference Excel
  </a>
</div>

  </div>

  {selectedFile && (
    <div className="mt-3">
      <p className="text-muted">Selected: {selectedFile.name}</p>
      <a
        href={URL.createObjectURL(selectedFile)}
        download={selectedFile.name}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-link p-0"
      >
        Click here to view or download the selected file
      </a>
    </div>
  )}
</Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setExcelModalOpen(false)}
                  style={{ backgroundColor: "#DA354E" }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={handleExcelUpload}
                  disabled={uploadLoading}
                  style={{ backgroundColor: "#1A54A5" }}
                >
                  {uploadLoading ? "Uploading..." : "Upload"}
                </Button>
              </Modal.Footer>
            </Modal>

            {userInfo && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setExcelModalOpen(true);
                }}
                className="quataiion text-blue-500 hover:underline cursor-pointer"
              >
                Upload excel quotation
              </a>
            )}
            {/* 
            {userInfo && (
              <a
                href="#"
                className="qua-rate pr-5"
                style={{ textDecoration: "none" }}
              >
                <i className="fa fa-shopping-cart" aria-hidden="true"></i>{" "}
                <span> AED {cartTotal}</span>
              </a>
            )} */}

            {userInfo !== null && (
              <div className="qua-rate pr-5 d-flex align-items-center">
                <i className="fa fa-money" aria-hidden="true"></i>{" "}
                <span
                  className={`ml-2 font-weight-bold ${
                    customerBalance < 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {Math.abs(customerBalance).toFixed(2)}
                </span>
              </div>
            )}
          </nav>
        </div>
      </div>
      <Modal
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        {/* <Modal.Header closeButton>
          <Modal.Title>&nbsp;</Modal.Title>
        </Modal.Header> */}
        <Modal.Body className="px-4 py-5 text-center">
          <i
            className="fa fa-exclamation-triangle"
            style={{ fontSize: "80px", color: "#DA354E" }}
          ></i>
          <br />
          <b>{confirmMessage}</b>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmModal(false)}
            style={{ backgroundColor: "#DA354E" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{ backgroundColor: "#1A54A5" }}
            onClick={() => {
              setConfirmModal(false);
              confirmAction && confirmAction();
            }}
          >
            Confirm
          </Button>
          {/* <Button
            variant="secondary"
            onClick={() => setConfirmModal(false)}
            style={{ backgroundColor: "#DA354E" }}
          >
            Cancel
          </Button> */}
        </Modal.Footer>
      </Modal>
    </header>
  );
};
